<template>
  <div
    class="text-center waiting-card"
  >
    <div
      v-if="practiceStatus"
      class="d-inline-flex align-center mt-2 provider-status"
    >
      <i class="pp-icon-provider" />
      {{ practiceStatus }}
    </div>
    <div class="justify-center align-center d-flex flex-column mt-2">
      <p>
        Thanks for joining the waiting room{{ practiceName }} Please ensure you're in a private setting for this visit.
      </p>
      <p>
        If this is an emergency, please dial 911
      </p>
      <p>
        Once your provider joins, you'll be asked to allow access to your computer's microphone & camera to start the video visit.
      </p>
      <p v-if="dropIn">
        If we're not expecting you at this time, please give us a call.
      </p>
      <iframe
        v-if="runTest"
        class="d-none"
        :src="iframeSrc"
      />
      <network-diagnostic-tool
        v-slot="diagnosticTool"
        :api-key="vonageApiKey"
        :video-session-info="dataFromIframe"
        class="mt-5"
        @start="runTestInIframe"
        @results="handleTestResults"
        @error="handleError"
      >
        <pp-button
          type="primary"
          text="Test Video &amp; Audio"
          @click="diagnosticTool.start"
        />
      </network-diagnostic-tool>
      <pp-snack-bar
        v-model="showErrorMessge"
        :snack-message="errorMessage"
      />
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { NetworkDiagnosticTool, VISIT_STATES } from 'sdk-vue-telehealth-visit'
const { mapGetters, createNamespacedHelpers } = Vuex
const { mapState } = createNamespacedHelpers('visitSession')
export default {
  name: 'WaitingForDoctor',
  components: {
    NetworkDiagnosticTool
  },
  data () {
    return {
      vonageApiKey: process.env.VUE_APP_VONAGE_API_KEY,
      dataFromIframe: {},
      runTest: false,
      showErrorMessage: false,
      errorMessage: '',
      practiceStatus: ''
    }
  },
  computed: {
    ...mapGetters({
      practiceInfo: 'practice/practiceInfo',
      appointmentType: 'appointmentType'
    }),
    ...mapState({
      receivedMessage: (state) => state.receivedMessage,
      serverState: (state) => state.clientStateSnapshot
    }),
    iframeSrc () {
      return window.location.origin + '/generate-test-session?practiceUuid=' + this.practiceInfo.practice_id
    },
    dropIn () {
      return this.appointmentType === 'drop-in'
    },
    practiceName () {
      let name = '.'
      if (this.practiceInfo.name) {
        name = ` for ${this.practiceInfo.name}.`
      }
      return name
    }
  },
  created () {
    window.onmessage = (e) => {
      if (e.data.sessionId) {
        this.dataFromIframe = e.data
      }
    }

    // mark patient as missed after 8 hours of connection
    setTimeout(() => {
      this.markVisitorAsMissed()
    }, 28800000)

    setInterval(() => {
      this.updatePracticeStatus()
    }, 1000)
  },
  methods: {
    runTestInIframe () {
      this.runTest = true
      this.$ppAnalytics.trackEvent({
        action: 'network_test',
        label: this.appointmentType
      })
    },
    handleTestResults (results) {
      this.trackResults('video_bitrate', results.video.bitrate / 1000)
      this.trackResults('video_mos', results.video.mos * 20)
      this.trackResults('audio_bitrate', results.audio.bitrate / 1000)
      this.trackResults('audio_mos', results.audio.mos * 20)
    },
    trackResults (action, value) {
      this.$ppAnalytics.trackEvent({
        action,
        label: this.appointmentType,
        value: Math.round(value)
      })
    },
    handleError () {
      this.errorMessage = {
        message: 'Please ensure you allow permission to use your camera and audio hardware.',
        status: 'error',
        duration: 3500
      }
      this.showErrorMessage = true
    },
    markVisitorAsMissed () {
      this.$ppAnalytics.trackEvent({
        action: 'patient_idle',
        label: this.appointmentType
      })
      this.$store.commit('visitSession/SET_STATE', {
        ...this.serverState,
        visitState: VISIT_STATES.MISSED
      })
    },
    updatePracticeStatus () {
      let returnStatus = 'isn\'t online yet'

      if (!this.receivedMessage) {
        this.practiceStatus = `${this.practiceInfo.name} ${returnStatus}`
        return
      }

      const receivedMessage = JSON.parse(this.receivedMessage)

      const providerPractice = receivedMessage.provider ? receivedMessage.provider : this.practiceInfo.name
      const timeSincePracticeLastUpdate = (new Date(Date.now()) - new Date(receivedMessage.timeStamp)) / 1000

      if (receivedMessage.status === 'online' && timeSincePracticeLastUpdate < 2) {
        returnStatus = 'is available'
      } else if (receivedMessage.status === 'busy' && timeSincePracticeLastUpdate < 2) {
        returnStatus = 'will join you shortly'
      }

      this.practiceStatus = `${providerPractice} ${returnStatus}`
    }
  }
}
</script>
<style lang="scss" scoped>
.waiting-card {
  position: relative;
  &__text {
    font-size: 1em;
    padding: 20px;
    min-height: 500px;
    width: 100%;
    @media screen and (max-width: 600px) {
      min-height: 320px;
    }
  }
}

.provider-status {
  background: #4A5472;
  padding: .5em;
  border-radius: .25em;
  color: #fff;
  font-size: .9em;

  i {
    height: 1.2em;
    margin-right: .5em;
  }
}
</style>
